import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Prompt } from 'react-router-dom';
// import ReactCountryFlag from 'react-country-flag';
import { compose, setDisplayName } from 'recompose';
import { debounce, get, pick, isEmpty } from 'lodash';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { withStyles } from '@material-ui/core/styles';
import { isMobile } from 'helpers/detect-mobile';
import qs from 'qs';

import {
  HeaderTitle,
  Helper,
  injectIntl,
  Paper,
  SmartForm,
  Tooltip,
} from 'components';
// import { countries } from 'constants/options';
import immutableToJS from 'helpers/immutableToJS';
import {
  dispatchMaker,
  formatPhoneNumber,
  generatePublicIdentifier,
  generatePublicIdentifierWithoutUnderscore,
  getMainUrlWithOutProtocol,
  getMainUrl,
} from 'helpers/utils';
import { findOrganization } from 'redux/accounts/actions';
import {
  sendNewPasswordLink,
  updateProfile,
  loginOrganization,
} from 'redux/auth/actions';
import { currentUserProfileSelector } from 'redux/auth/selectors';
import { getDataSelector, getRequestingSelector, selectState } from 'redux/selectors';
import { setLocale } from 'redux/ui/actions';

import AddressForm from './components/AddressForm';
import DeliverySchedule from './components/DeliverySchedule';
import LicenseImage from './components/LicenseImage';
import ProfileCard from './components/ProfileCard';

const styles = theme => ({
  requestButton: {
    backgroundColor: '#ffd24c',
    borderRadius: 5,
    marginBottom: 10,
    position: 'absolute',
    top: -5,
    [theme.breakpoints.down('xs')]: {
      top: -50,
      left: 0,
    },
  },
  requestButtonLabel: {
    color: '#313131',
    fontSize: 14,
    fontWeight: 500,
  },
});


class Profile extends Component {
  static contextTypes = {
    currentMember: PropTypes.shape({}),
    currentUser: PropTypes.shape({}),
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
    readOnly: PropTypes.bool,
    noDistributor: PropTypes.bool,
    setHotNotification: PropTypes.func,
  };

  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    profile: PropTypes.shape({
      companyName: PropTypes.string,
    }).isRequired,
    roles: PropTypes.arrayOf(PropTypes.shape({})),
    organizationFound: PropTypes.shape({}),
    organizationFoundRequesting: PropTypes.bool,
    tokenInfoRequesting: PropTypes.bool,

    findOrganization: PropTypes.func.isRequired,
    loginOrganization: PropTypes.func.isRequired,
    setLocale: PropTypes.func.isRequired,
    sendNewPasswordLink: PropTypes.func.isRequired,
    updateProfile: PropTypes.func.isRequired,
    history: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    organizationFound: {},
    organizationFoundRequesting: false,
    roles: [],
    tokenInfoRequesting: false,
  };

  state = {
    companyName: this.props.profile.companyName || '',
    dirty: false,
    selectedRoleId: null,
  };

  getCommonFields = (details, asConsumerForm) => {
    const { currentUser, readOnly, noDistributor } = this.context;
    const { formatMessage, sendNewPasswordLink, roles, organizationFoundRequesting, organizationFound } = this.props;
    const currentAccount = currentUser.account || {}; // login as
    const isOrganization = Boolean(details.currentRoleId) || currentUser.organizations.filter(o => o.account.currentRoleId != null).length === 0;
    const { organizations } = currentUser;
    const { account } = organizations[0]; // login root
    const role = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[currentAccount.currentRoleId] || 'Personal';
    const isReadOnly = readOnly || (currentAccount.email !== account.email && (role === 'Buyer' || role === 'Distributor' || role === 'Seller'));
    const filteredRoles = asConsumerForm ? roles.filter(role => role.name === 'Consumer') : roles.filter(role => role.name != 'Consumer');
    /* const locales = countries.map(country => ({
      label: (
        <div
          className="flag-label"
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'flex-start',
            width: 115,
          }}
        >
          <ReactCountryFlag
            code={country.flag}
            flagProps={{ fontSize: '4rem' }}
          />
          <div style={{ paddingLeft: 10 }}>{country.label}</div>
        </div>
      ),
      value: country.code,
    })); */

    const userNameError = this.state.companyName!= '' && !organizationFoundRequesting &&   !isEmpty(organizationFound) && organizationFound.id != -1 && (
        <div style={{color:'red'}}>
          <Tooltip
            tooltip={formatMessage('This username is already taken.')}
          >
            <ErrorIcon color="error" />
          </Tooltip>
          <span>{formatMessage('This username is already taken')}</span>
        </div>
    );

    const fields = [];
    if (!asConsumerForm) {
      fields.push({
        defaultValue: isOrganization ? 'Account Owner' : 'Member Account',
        fieldName: 'userInfo',
        kind: 'blank',
        label: formatMessage(isOrganization ? 'Account Owner' : 'Member Account'),
        name: 'userInfo',
        fontSize: 30,
        readOnly: true,
      });
    }

    if (isOrganization) {
      fields.push({
        defaultValue: 'Business Type',
        kind: 'blank',
        label: formatMessage('User Type'),
        name: 'businessType',
        fontSize: 30,
        readOnly: true,
      });
      if (asConsumerForm) {
        fields.push({
          kind: 'return',
          name: 'ReturnUserInfo',
        });
      }
      // if (asConsumerForm) {
      //   fields.push({
      //     defaultValue: 'Business Name or Username',
      //     fieldName: 'organizationAccount',
      //     kind: 'blank',
      //     label: formatMessage('Username'),
      //     name: 'organizationAccount',
      //     fontSize: 30,
      //     readOnly: true,
      //   });
      // }
    } else {
      fields.push({
        kind: 'return',
        name: 'ReturnUserInfo',
      });
    }

    if (!asConsumerForm) {
      fields.push({
        error: true,
        fieldName: 'email',
        kind: 'input',
        label: formatMessage('Email - Account Owner'),
        name: 'email',
        readOnly: true,
        required: true,
      });
    }

    if (isOrganization) {
      fields.push({
        defaultValue:  details.currentRoleId || 2,
        hasLabel: false,
        kind: 'select',
        name: 'currentRoleId',
        options: filteredRoles.map(role => ({
          ...role,
          label: formatMessage(role.name),
          value: role.id,
        })).filter(role => (
          (!noDistributor || role.name !== 'Distributor') && role.name !== 'Administrator'
        )),
        readOnly: Boolean(details.currentRoleId),
        required: true,
        userType: Boolean(details.currentRoleId),
        onChange: (currentRoleId) => {
          this.setState({ selectedRoleId: currentRoleId });
        },
      });
      if (asConsumerForm) {
        fields.push({
          kind: 'return',
          name: 'ReturnEmailAddress',
        });
        fields.push({
          kind: 'return',
          name: 'ReturnUserInfo',
        });
        fields.push(
          {
            kind: 'blank',
            name: 'userInfo',
            fontSize: 12,
            label: (
              <div>
                {userNameError}
              </div>
            ),
          },
        );
      }
      // if (asConsumerForm) {
      //   fields.push({
      //     error: true,
      //     fieldName: 'companyName',
      //     kind: 'input',
      //     label: formatMessage('Name'),
      //     name: 'companyName',
      //     readOnly: isReadOnly,
      //     required: true,
      //     render: () => this.state.companyName,
      //     onChange: (companyName) => {
      //       this.setState(
      //         { companyName },
      //         this.handleFindOrganization,
      //       );
      //     },
      //   });
      // }
    } else {
      fields.push({
        kind: 'return',
        name: 'ReturnEmailAddress',
      });
    }

    if (asConsumerForm) {
      fields.push({
        error: true,
        fieldName: 'email',
        kind: 'input',
        label: formatMessage('Email - Account Owner'),
        name: 'email',
        readOnly: true,
        required: true,
      });
    }

    if (asConsumerForm) {
      fields.push({
        fieldName: 'mobile',
        kind: 'input',
        label: formatMessage('Mobile'),
        name: 'mobile',
        readOnly: isReadOnly,
        required: true,
        render: data => data.mobile,
      });
    }

    fields.push({
      fieldName: 'firstName',
      kind: 'input',
      label: formatMessage('First Name'),
      name: 'firstName',
      readOnly: isReadOnly,
      required: true,
    },
    {
      fieldName: 'lastName',
      kind: 'input',
      label: formatMessage('Last Name'),
      name: 'lastName',
      readOnly: isReadOnly,
      required: true,
    });

    if (asConsumerForm) {
      fields.push({
        kind: 'return',
        name: 'ReturnLastName',
      });
    }

    if (!asConsumerForm) {
      fields.push({
        fieldName: 'mobile',
        kind: 'input',
        label: formatMessage('Mobile'),
        name: 'mobile',
        readOnly: isReadOnly,
        required: true,
        render: data => data.mobile,
      });
    }

    if (!asConsumerForm && role !== 'Consumer' && !(currentAccount.email !== account.email && (role === 'Buyer' || role === 'Distributor' || role === 'Seller'))) {
      fields.push({
        kind: 'button',
        label: formatMessage('Email New Password Link'),
        name: 'newPasswordLink',
        readOnly,
        onClick: () => sendNewPasswordLink({ email: currentAccount.email }),
      });
    } else {
      fields.push({
        kind: 'return',
        name: 'newPasswordLink',
      });
    }

    if (isMobile) {
      const fieldtToSwap = fields[1];
      fields[1] = fields[2];
      fields[2] =  fieldtToSwap;
    }
    return fields;
  };

  getCompanyFields = (details, asConsumerForm) => {
    const {
      currentUser,
      isRestaurant,
      isConsumer,
      readOnly,
    } = this.context;
    const {
      formatMessage,
      organizationFound,
      organizationFoundRequesting,
      history,
      profile: {
        deliverySchedule = [],
      },
    } = this.props;

    const { companyName, selectedRoleId } = this.state;
    const currentAccount = currentUser.account || {}; // login as

    const selectedRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[selectedRoleId] || 'Personal';

    const isOrganization = Boolean(details.currentRoleId) || currentUser.organizations.filter(o => o.account.currentRoleId != null).length === 0;

    const companyFields = [];

    const { organizations } = currentUser;
    const { account } = organizations[0]; // login root
    const role = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[currentAccount.currentRoleId] || 'Personal';
    const isReadOnly = readOnly || (currentAccount.email !== account.email && (role === 'Buyer' || role === 'Distributor' || role === 'Seller'));
    const businessNameLabel = isMobile ? !asConsumerForm ? 'Business or Username' : 'Username' : !asConsumerForm ? 'Business Name or Username' : 'Username';
    // These are also shown when you toggle on Organization Account in Personal account
    if (!asConsumerForm) {
      companyFields.push(
        {
          defaultValue: 'Business Name or Username',
          fieldName: 'organizationAccount',
          kind: 'blank',
          label: formatMessage(businessNameLabel),
          name: 'organizationAccount',
          fontSize: 30,
          readOnly: true,
        },
        {
          kind: 'return',
          name: 'ReturnOrganizationAccount',
        },
      );
    }
    const publicPath = `${getMainUrl()}/shop@${generatePublicIdentifierWithoutUnderscore(companyName)}`;
    const displyPublicPath = `${getMainUrlWithOutProtocol()}/shop@${generatePublicIdentifierWithoutUnderscore(companyName)}`;
    
    const iconOrg = organizationFoundRequesting ? '...' : (
      organizationFound && organizationFound.id ? (
        <Tooltip
          tooltip={formatMessage('This url is already taken. Please change your company name.')}
        >
          <ErrorIcon color="error" />
        </Tooltip>
      ) : (
        <Tooltip
          tooltip={formatMessage('Available')}
        >
          <CheckCircleIcon color="primary" />
        </Tooltip>
      )
    );

    if (!asConsumerForm) {
      companyFields.push(
        {
          error: true,
          fieldName: 'companyName',
          kind: 'input',
          label: formatMessage('Name'),
          name: 'companyName',
          readOnly: isReadOnly,
          required: true,
          render: () => this.state.companyName,
          onChange: (companyName) => {
            this.setState(
              { companyName },
              this.handleFindOrganization,
            );
          },
        },
      );
      if (selectedRole !== 'Buyer' && role !== 'Buyer') {
        companyFields.push(
          {
            kind: 'blank',
            label: (
              <div>
                {formatMessage('Your Public Profile Link')}&nbsp;{iconOrg}<a href={publicPath} target="_blank" className="your-profile-link">{publicPath}</a>
              </div>
            ),
          },
        );
      } else {
        companyFields.push(
          {
            kind: 'return',
          },
        );
      }
    } else {
      companyFields.push(
        {
          kind: 'return',
          name: 'ReturnCompanyName',
        },
      );
    }

    if (currentAccount.currentRoleId && !isRestaurant && !asConsumerForm) {
      companyFields.push(
        {
          fieldName: 'organicNumber',
          kind: 'input',
          label: formatMessage(isRestaurant ? 'Organic Number' : 'Organic Handler Number'),
          name: 'organicNumber',
          readOnly,
        },
        {
          kind: 'return',
          name: 'ReturnOrganicNumber',
        },
      );
    }

    if (currentAccount.currentRoleId && !asConsumerForm) {
      companyFields.push(
        // {
        //   fieldName: 'linkToTeamMember',
        //   kind: 'blank',
        //   label: (
        //     <div
        //       onClick={() => history.push('/settings/add-company-members')}
        //       style={{
        //         cursor: 'pointer',
        //         color: '#359aff',
        //       }}
        //     >
        //       {formatMessage('Manage Team Members')}
        //     </div>
        //   ),
        //   name: 'linkToTeamMember',
        // },
        // License or Certificate image upload
        {
          fieldName: 'licenseImageUpload',
          kind: 'blank',
          label: <LicenseImage image={details.licenseImageUrl} />,
          name: 'licenseImageUpload',
        },
        {
          kind: 'return',
          name: 'ReturnLicenseImage',
        },
      );
    }

    if (currentAccount.currentRoleId && !isRestaurant && !asConsumerForm) {
      companyFields.push(
        {
          fieldName: 'nextInvoiceNumber',
          kind: 'input',
          label: formatMessage('Next Invoice #'),
          name: 'nextInvoiceNumber',
          readOnly: isReadOnly,
          type: 'number',
        },
      );
    }

    if (currentAccount.currentRoleId && !isRestaurant && !asConsumerForm) {
      companyFields.push(
        {
          kind: 'blank',
          label: (
            <DeliverySchedule
              deliverySchedule={deliverySchedule}
              formatMessage={formatMessage}
              readOnly={readOnly}
              update={this.updateDeliverySchedule}
            />
          ),
          name: 'delivery-schedule-calendar',
        },
      );
    }

    if (!asConsumerForm) {
      companyFields.push(
        {
          kind: 'blank',
          label: formatMessage('Addresses'),
          name: 'address-label',
        },
        {
          kind: 'return',
          name: 'ReturnAddress',
        },
      );
    }

    companyFields.push(
      {
        kind: 'blank',
        label: (
          <AddressForm
            addresses={get(currentAccount, 'profile.addresses') || []}
            onUpdate={this.setFormDirty}
            asConsumerForm={asConsumerForm}
          />
        ),
        fullWidth: true,
        name: 'addresses',
      },
    );

    if (isOrganization && !asConsumerForm) {
      companyFields.push({
        defaultValue: 'Account Bio',
        fieldName: 'userInfo',
        kind: 'blank',
        label: formatMessage('Account Bio'),
        name: 'userInfo',
        fontSize: 30,
        readOnly: true,
      },
      {
        kind: 'return',
        name: 'ReturnAccountBio',
      },
      {
        fieldName: 'bio',
        fullWidth: true,
        kind: 'textarea',
        label: formatMessage('Bio'),
        name: 'bio',
        readOnly,
      },
      {
        kind: 'return',
        name: 'ReturnBio',
      });
    }

    return companyFields;
  };

  getFields = (details) => {
    const {
      readOnly,
      currentUser,
      isConsumer,
    } = this.context;
    const { history } = this.props;
    const isOrganization = Boolean(details.currentRoleId) || currentUser.organizations.filter(o => o.account.currentRoleId != null).length === 0;
    const { asConsumer } = qs.parse(history.location.search.slice(1));
    const invitedAsConsumer = asConsumer && JSON.parse(asConsumer);
    const asConsumerForm = isConsumer || invitedAsConsumer;
    
    const commonFields = this.getCommonFields(details, asConsumerForm);
    const companyFields = this.getCompanyFields(details, asConsumerForm);

    if (readOnly) {
      commonFields.splice(0, 1, {
        kind: 'return',
        name: 'ReturnEmail',
      });
    }

    const fields = [];
    fields.push(...commonFields);

    if (isOrganization) {
      fields.push(...companyFields);
    }

    return fields;
  }

  setFormDirty = () => {
    this.setState({ dirty: true });
  };

  changeLocale = (e) => {
    const { setLocale } = this.props;
    setLocale(e);
  }

  findOrganization = () => {
    const { findOrganization } = this.props;
    const { companyName } = this.state;
    findOrganization({ organizationUID: generatePublicIdentifier(companyName) });
  };

  handleFindOrganization = debounce(this.findOrganization, 300);

  isDeactivated = () => {
    const { currentMember, currentUser } = this.context;
    const { history } = this.props;

    let deactivated = false;
    if (!currentMember && currentUser) {
      const {
        account: {
          profile: {
            firstName,
            lastName,
            mobile,
            companyName,
            addresses,
          },
        },
        roleId,
      } = currentUser || { account: { profile: { addresses: [{}] } } };

      const { address, city, state, zipcode } = addresses && addresses.length ? addresses[0] : {};

      if (roleId && (!firstName || !lastName || !mobile || !companyName
        || !address || !city || !state || !zipcode)) {
        deactivated = true;
      }
      if (!roleId && (!firstName || !lastName || !mobile)) {
        deactivated = true;
      }
    }
    return deactivated;
  }

  updateContacts = (contacts) => {
    this.contacts = contacts;
  }

  updateDeliverySchedule = (deliverySchedule) => {
    this.deliverySchedule = deliverySchedule;
    this.setFormDirty();
  };

  updateProfile = (data) => {
    const { currentUser, isRestaurant, setHotNotification, isConsumer } = this.context;
    const { updateProfile, history } = this.props;
    const addresses = [];
    if (data.address) {
      if (typeof data.address === 'string') {
        addresses.push({
          address: data.address,
          city: data.city,
          state: data.state,
          zipcode: data.zipcode,
        });
      } else {
        for (let i = 0; i < data.address.length; i++) {
          if (
            data.address[i].trim() !== '' ||
            data.city[i].trim() !== '' ||
            data.state[i].trim() !== '' ||
            data.zipcode[i].trim() !== ''
          ) {
            addresses.push({
              address: data.address[i],
              city: data.city[i],
              state: data.state[i],
              zipcode: data.zipcode[i],
            });
          }
        }
      }
    }

    let modifiedData = {};
    const isOrganization = Boolean(get(currentUser, 'account.currentRoleId')) || currentUser.organizations.filter(o => o.account.currentRoleId != null).length === 0;
    if (!isOrganization) {
      modifiedData = pick(data, ['email', 'firstName', 'lastName', 'mobile', 'bio']);
    } else {
      modifiedData = pick(data, ['companyName', 'email', 'firstName', 'lastName', 'mobile', 'addresses', 'organicNumber', 'nextInvoiceNumber', 'bio']);
      if (currentUser.account.currentRoleId === 3 || currentUser.account.currentRoleId === 4) {
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(modifiedData.nextInvoiceNumber) || modifiedData.nextInvoiceNumber <= 0) {
          setHotNotification('Next invoice cannot be 0 or less.');
          return;
        }
      }

      modifiedData.companyName = isConsumer ? modifiedData.firstName + ' ' + modifiedData.lastName : modifiedData.companyName;
      modifiedData.currentRoleId = parseInt(data.currentRoleId[0], 10);
      modifiedData.addresses = addresses;
      modifiedData.associatedEmails = this.contacts;
      modifiedData.deliverySchedule = this.deliverySchedule;
    }
    // [modifiedData.locale] = data.currentLocale;
    this.changeLocale(modifiedData.locale);
    updateProfile(modifiedData, { onSuccess: (data) => {
      const { redirect_url: redirectUrl, profileUrl } = qs.parse(history.location.search.slice(1));
      const { currentUser } = this.context;
      if (redirectUrl) {
        if (redirectUrl === 'shop') {
          const pathname = '/shop';
          history.push(pathname);
          window.location.href = pathname;
        } else {
          history.push(`/${decodeURI(redirectUrl)}`);
        }
      } else if (profileUrl) {
        const pathname = profileUrl ? `/${decodeURI(profileUrl)}?connect=true` : '';
        history.push(pathname);
        window.location.href = pathname;
      } else {
        // history.push('/settings-saved');
        if (currentUser.roleId === 5) {
          const freshrSellerId = 2543;
          history.push(`/order?suid=${freshrSellerId}`);
        }
      }
    }});
    this.setState({ dirty: false });
  }

  handleOrganizationClick = (memberId) => {
    const { history } = this.props;
    this.props.loginOrganization({
      memberId,
      onSuccess: (data) => {
        if (data) {
          const role = {
            2: 'Buyer',
            3: 'Distributor',
            4: 'Seller',
            5: 'Consumer',
          }[data.user.account.currentRoleId] || 'Personal';
          if (role === 'Personal') {
            history.push('/settings');
            window.location.reload();
          } else {
            const { profileUrl } = qs.parse(history.location.search.slice(1));
            if (profileUrl) {
              const pathname = profileUrl ? `/${decodeURI(profileUrl)}?connect=true` : '';
              history.push(pathname);
              window.location.href = pathname;
            } else {
              history.push('/track-orders');
              window.location.reload();
            }
          }
        }
      },
    });
  };

  render() {
    const { currentUser, readOnly} = this.context;
    const {
      formatMessage,
      organizationFound,
      tokenInfoRequesting,
      updateProfile,
    } = this.props;
    const { dirty } = this.state;
    const isDeactivated = this.isDeactivated();
    const account = currentUser.account || {};
    const details = {};
    details.currentRoleId = account.currentRoleId;
    details.email = account.email;
    details.companyName = account.profile.companyName;
    details.firstName = account.profile.firstName;
    details.lastName = account.profile.lastName;
    details.mobile = account.profile.mobile;
    details.organicNumber = account.profile.organicNumber;
    details.nextInvoiceNumber = account.profile.nextInvoiceNumber || 1;
    details.bio = account.profile.bio;
    details.licenseImageUrl = account.profile.licenseUrl;

    const fields = this.getFields(details);
    const isPending = currentUser.organizations.filter(o => !!o.account.currentRoleId && !o.pending).length === 0;
    const isOrganization = Boolean(account.currentRoleId) || currentUser.organizations.filter(o => o.account.currentRoleId != null).length === 0;
    const renderOrganizations = (ogs) => {
      const organizations = ogs.filter(o => !!o.account.currentRoleId && !o.pending);
      if (organizations.length === 1) {
        return (<span style={{ color: '#4594EB', cursor: 'pointer' }} onClick={() => this.handleOrganizationClick(organizations[0].id)} >{organizations[0].account.profile.companyName}</span>);
      }

      if (organizations.length === 2) {
        return (
          <span>
            <span style={{ color: '#4594EB', cursor: 'pointer' }} onClick={() => this.handleOrganizationClick(organizations[0].id)}>{organizations[0].account.profile.companyName}</span> and&nbsp;
            <span style={{ color: '#4594EB', cursor: 'pointer' }} onClick={() => this.handleOrganizationClick(organizations[1].id)}>{organizations[1].account.profile.companyName}</span>
          </span>
        );
      }

      return (
        <span>
          {
            organizations.map((o, i) => {
              if (i === organizations.length - 1) {
                return (<span style={{ color: '#4594EB', cursor: 'pointer' }} onClick={() => this.handleOrganizationClick(o.id)}>{o.account.profile.companyName}</span>);
              }
              if (i === organizations.length - 2) {
                return (<span><span style={{ color: '#4594EB', cursor: 'pointer' }} onClick={() => this.handleOrganizationClick(o.id)}>{o.account.profile.companyName}</span> and </span>);
              }
              return (<span><span style={{ color: '#4594EB', cursor: 'pointer' }} onClick={() => this.handleOrganizationClick(o.id)}>{o.account.profile.companyName}</span>, </span>);
            })
          }
        </span>
      );
    };
    return (
      <Paper indicator noPadding loading={tokenInfoRequesting}>
        <HeaderTitle>{formatMessage('Settings')}</HeaderTitle>
        <Helper name="account-details" />
        <ProfileCard
          bio={account.profile.bio}
          details={currentUser}
          expanded
          imageEditable={!readOnly}
          index={0}
          initialExpand
          noPadding
          updateProfile={updateProfile}
        >
          {isDeactivated && (
          <div style={{
            backgroundColor: 'rgba(255,229,100,.3)',
            borderLeftColor: '#ffe564',
            borderLeft: '4px solid #ffe564',
            padding: '1.2rem 1.2rem 1.2rem calc(1rem - 4px)',
            marginLeft: '-1rem',
            marginBottom: '2rem' }}><strong>{formatMessage('Note: ')}</strong>
            <span style={{ color: '#f86c6b' }}>{formatMessage('You must fill in all required fields to use FRESHr.')}</span>
          </div>
          )}
          {!isOrganization && !isDeactivated && !isPending && (
            <div style={{ fontWeight: 500, fontSize: '16px' }}>
              You are a Member of {renderOrganizations(currentUser.organizations)} Business Accounts
            </div>
          )}
          <SmartForm
            actionClass="profile-action"
            actionsTop
            addConfirm
            placeChildrenBottom
            isOrganization={isOrganization}
            defaultData={details}
            fields={fields}
            onSave={this.updateProfile}
            onUpdate={this.setFormDirty}
            saveButton={formatMessage('SAVE SETTINGS')}
            saveButtonDisable={
              readOnly || tokenInfoRequesting || (organizationFound && organizationFound.id)
            }
            saveConfirm={!currentUser.roleId && isOrganization ? formatMessage('Create a business account with a user type: ') : ''}
          />
        </ProfileCard>
        <Prompt
          message={formatMessage('Pending Changes')}
          when={dirty}
        />
      </Paper>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  profile: currentUserProfileSelector(state),
  roles: getDataSelector('options', 'roles')(state),
  tokenInfoRequesting: getRequestingSelector('auth', 'tokenInfo')(state),
  ...selectState('accounts', 'organizationFound')(state),
});

export default compose(
  setDisplayName('Profile'),
  connect(
    mapStateToProps,
    dispatch => ({
      ...dispatchMaker([
        [updateProfile, 'updateProfile'],
      ])(dispatch),
      loginOrganization: payload => dispatch(loginOrganization(payload)),
      findOrganization: payload => dispatch(findOrganization(payload)),
      setLocale: payload => dispatch(setLocale(payload)),
      sendNewPasswordLink: payload => dispatch(sendNewPasswordLink(payload)),
    }),
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(Profile);
